import { SITE_CONTENT } from "../constants/siteContent";

/*
 * One place that builds direct-contact links, so the header, the sticky mobile
 * dock, the contact page and the lead form can never drift apart on the number
 * or on how the pre-filled message is encoded.
 *
 * Everything reads SITE_CONTENT.contact — change the number there, not here.
 */

const CONTACT = SITE_CONTENT.contact || {};

/* wa.me wants the country code with no "+", spaces or dashes. Strip anything
   else defensively so a prettified number in SITE_CONTENT still works. */
function normalizeWaNumber(value) {
  return String(value || "").replace(/[^\d]/g, "");
}

/**
 * Build a WhatsApp deep link with an optional pre-filled opener.
 *
 * @param {string} [messageKey] key into SITE_CONTENT.contact.messages
 *                              ("default" | "quote" | "call" | "zeta"), or a
 *                              literal message string.
 * @returns {string} a wa.me URL, or "" when no number is configured (callers
 *                   must render nothing rather than a dead link).
 */
export function whatsappUrl(messageKey = "default") {
  const number = normalizeWaNumber(CONTACT.whatsapp);
  if (!number) return "";

  const messages = CONTACT.messages || {};
  const text =
    messages[messageKey] !== undefined ? messages[messageKey] : messageKey;

  const base = `https://wa.me/${number}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
}

/** tel: link for the published number, or "" when unset. */
export function telUrl() {
  const raw = CONTACT.phoneHref || CONTACT.phoneDisplay || "";
  const cleaned = String(raw).replace(/[^\d+]/g, "");
  return cleaned ? `tel:${cleaned}` : "";
}

/** mailto: link, or "" when unset. */
export function mailUrl(subject) {
  const email = CONTACT.email || "";
  if (!email) return "";
  return subject
    ? `mailto:${email}?subject=${encodeURIComponent(subject)}`
    : `mailto:${email}`;
}

/** The human-readable number, for display next to the link. */
export function phoneDisplay() {
  return CONTACT.phoneDisplay || "";
}

/** Short reassurance line shown under a contact CTA. May be "". */
export function responseNote() {
  return CONTACT.responseNote || "";
}

/* Attributes every outbound WhatsApp link needs. noreferrer is deliberate:
   without it the target sees our URL in the Referer header. */
export const EXTERNAL_LINK_PROPS = {
  target: "_blank",
  rel: "noreferrer"
};

export default whatsappUrl;
